<p-card header="Teller's Information">
  <button
    pButton
    pRipple
    label="Add Teller"
    class="p-button-success mb-3"
    (click)="onClickAdd()"
  ></button>
  <div class="card">
    <p-table
      #dt1
      [value]="agents"
      [tableStyle]="{ 'min-width': '50rem' }"
      [paginator]="true"
      [rows]="10"
      [rowsPerPageOptions]="[10, 25, 50, 100, 1000, 10000]"
      [globalFilterFields]="['name', 'usercode']"
    >
      <ng-template pTemplate="caption">
        <div class="flex">
          <!-- <button
            pButton
            label="Clear"
            class="p-button-outlined"
            icon="pi pi-filter-slash"
            (click)="clear(dt1)"
          ></button> -->
          <span class="p-input-icon-left ml-auto">
            <i class="pi pi-search"></i>
            <input
              pInputText
              type="text"
              (input)="dt1.filterGlobal($any($event.target).value, 'contains')"
              placeholder="Search keyword"
            />
          </span>
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th>Name</th>
          <th>Usercode</th>
          <th>Operator</th>
          <th>Group</th>
          <th>Password</th>
          <!-- <th>Version</th> -->
          <!-- <th>QR</th> -->
          <th>Action</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-agent>
        <tr>
          <td>{{ agent.name }}</td>
          <td>{{ agent.usercode }}</td>
          <td>{{ agent.operator }}</td>
          <td>{{ agent.group }}</td>
          <td>{{ agent.password }}</td>
          <!-- <td>{{ agent.version }}</td> -->
          <!-- <td>{{ agent.qrposition }}</td> -->
          <td>
            <p-button
              class="mx-1"
              icon="pi pi-user-edit"
              styleClass="p-button-rounded p-button-warning"
              (onClick)="EditInfo(agent)"
            ></p-button>
            <p-button
              icon="pi pi-trash"
              styleClass="p-button-rounded p-button-danger"
              (onClick)="Delete(agent.usercode)"
            ></p-button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</p-card>

<p-dialog header="ADD" [(visible)]="visible" [style]="{ width: '50vw' }">
  <div class="grid">
    <div class="col-6">
      <div class="flex flex-column gap-2">
        <label htmlFor="username">Name</label>
        <input
          pInputText
          id="name"
          aria-describedby="name-help"
          [(ngModel)]="name"
        />
      </div>
    </div>
    <div class="col-6">
      <div class="flex flex-column gap-2">
        <label htmlFor="operator">Operator</label>
        <p-dropdown
          [style]="{ width: '100%' }"
          optionLabel="value"
          placeholder="Select a Operator"
          [showClear]="true"
          optionValue="value"
          [options]="operator"
          [(ngModel)]="selectedoperator"
        ></p-dropdown>
      </div>
    </div>
    <div class="col-3">
      <div class="flex flex-column gap-2">
        <label htmlFor="group">Group</label>
        <p-dropdown
          [style]="{ width: '100%' }"
          optionLabel="name"
          placeholder="Select a Group"
          [showClear]="true"
          optionValue="name"
          [options]="grourpname"
          [(ngModel)]="selectednames"
        ></p-dropdown>
      </div>
    </div>
    <!-- <div class="col-3">
      <div class="flex flex-column gap-2">
        <label htmlFor="group">QR Position</label>
        <p-dropdown
          [style]="{ width: '100%' }"
          optionLabel="value"
          placeholder="Select a Group"
          [showClear]="true"
          optionValue="value"
          [options]="qrposition"
          [(ngModel)]="selectedqrposition"
        ></p-dropdown>
      </div>
    </div> -->
    <!-- <div class="col-4">
      <div class="flex flex-column gap-2">
        <label htmlFor="version">Version</label>
        <p-dropdown
          appendTo="body"
          [style]="{ width: '100%' }"
          optionLabel="value"
          placeholder="Select a Version"
          [showClear]="true"
          optionValue="value"
          [options]="version"
          [(ngModel)]="selectednversion"
        ></p-dropdown>
      </div>
    </div> -->
    <div class="col-3">
      <div class="flex flex-column gap-2">
        <label htmlFor="usercode">User Code</label>
        <input
          pInputText
          id="usercode"
          aria-describedby="usercode-help"
          [(ngModel)]="usercode"
        />
      </div>
    </div>
    <div class="col-5">
      <div class="flex flex-column gap-2">
        <label htmlFor="password">Password</label>

        <input
          pInputText
          id="password"
          aria-describedby="password-help"
          [(ngModel)]="password"
          disabled="true"
        />
      </div>
    </div>
    <div class="col-1 mt-5">
      <p-button
        icon="pi pi-refresh"
        severity="info"
        (onClick)="ResetPassword()"
      ></p-button>
    </div>
    <!-- <div class="col-3">
      <div class="flex flex-column gap-2">
        <label htmlFor="password">2</label>
        <button pButton>Reset</button>
      </div>
    </div> -->
  </div>
  <div class="flex flex-row-reverse flex-wrap">
    <button
      pButton
      pRipple
      label="{{ labelString }}"
      class="p-button-info mt-3 ml-2"
      (click)="AddUpdate()"
    ></button>
  </div>
</p-dialog>
